import { tVariants } from '../../../style-system';

const editableTextStyles = tVariants({
    base: 'min-w-8 inline-block focus-within:text-content text-content-muted placeholder:text-content-deselected',
});

export { editableTextStyles };
